import { render, staticRenderFns } from "./App.vue?vue&type=template&id=bf4f3af4&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style1 from "./App.vue?vue&type=style&index=1&id=bf4f3af4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4f3af4",
  null
  
)

export default component.exports